import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import type { Seat } from "./types"

// Query keys
export const seatKeys = {
  all: ["seats"] as const,
  lists: () => [...seatKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...seatKeys.lists(), { filters }] as const,
}

// Hook to fetch seats with optional filters
export const useSeats = (filters?: Record<string, unknown>) => {
  return useQuery({
    queryKey: seatKeys.list(filters || {}),
    queryFn: async () => {
      const response = await axios.get<Seat[]>("/api/myteconstruction/seats", {
        params: filters,
      })
      return response.data
    },
  })
}

// Hook to fetch seats for a specific project
export const useProjectSeats = (projectId: string) => {
  return useSeats({ projectId })
}

// Hook to fetch available seats (not assigned to any project)
export const useAvailableSeats = (role?: string) => {
  return useSeats({ projectId: "null", role, status: "active" })
}
